import { SET_USER_SETTING, UPDATE_USER_SETTINGS } from '../constants/actionTypes';

const initialState = {
    actionButtonPosition: 2,
    appearanceMode:       0,
    language:             0,
    playerListSettings:   {}
};

const reducer = ( state = initialState, action ) => {

    // console.log( 'reducers.userSettings', state, action );

    switch ( action.type ) {

        case SET_USER_SETTING: {

            const { setting, value } = action.payload;

            return { ...state, [ setting ]: value };

        }

        case UPDATE_USER_SETTINGS: {

            return { ...action.payload.userSettings };

        }

        default:

            return state;

    }

};

export default reducer;